// extracted by mini-css-extract-plugin
module.exports = {"previewBg":"FeaturedBannersGallery_previewBg__cGxUq"};